import { InputType } from '@import/enums/input-type.enum';
import { ColumnType } from '@import/interfaces';

export const PersonalAddressColumnsTypes: ColumnType[] = [
    {
        label: 'Street Address',
        relatedLabels: ['Address', 'Address 1', 'Street Address'],
        translatableLabel: 'import.columnTypes.streetAddress',
        serializeName: 'address.addressLine1',
        input: InputType.string,
        required: false,
        requiredWith: ['address'],
    },
    {
        label: 'Unit/Suite',
        relatedLabels: ['Address 2', 'Unit/Suite'],
        translatableLabel: 'import.columnTypes.unitOrSuite',
        serializeName: 'address.addressLine2',
        input: InputType.string,
        required: false,
    },
    {
        label: 'City',
        translatableLabel: 'import.columnTypes.city',
        serializeName: 'address.city',
        input: InputType.string,
        required: false,
        requiredWith: ['address'],
    },
    {
        label: 'Province',
        relatedLabels: ['Region'],
        translatableLabel: 'import.columnTypes.province',
        serializeName: 'address.province',
        input: InputType.string,
        required: false,
        requiredWith: ['address'],
    },
    {
        label: 'Postal Code',
        relatedLabels: ['Zip Code'],
        translatableLabel: 'import.columnTypes.postalCode',
        serializeName: 'address.postalCode',
        input: InputType.string,
        required: false,
        requiredWith: ['address'],
    },
    {
        label: 'Country',
        translatableLabel: 'import.columnTypes.country',
        serializeName: 'address.country',
        input: InputType.string,
        required: false,
        requiredWith: ['address'],
    },
];
